import { EmployeeContactUserResolver } from './../users/services/user.resolver.service';
import { EcplDocumentExplorerModule } from 'src/app/shared/ecpl-document-explorer';

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { SafetyjobComponent } from './jobanalysis.component';
import { JobAnalysisService } from './services/jobanalysis.services';
import { FormComponent } from './components/safety-job-form.component';
import { NewComponent } from './components/new-safety-job-analysis.component';
import { ListComponent } from './components/safety-job-list.component';
import {
  SafteyJobEditResolver,
  SafteyJobListResolver,
  TypeOfIssueResolver,
  TopicResolver,
  SJAApprovalNoticeListResolver,
} from './services/jobanalysis.resolver.services';
import { Safetyjob } from './models/index';
import { AppSharedModule } from './../shared/appShared.module';
import { TranslatePipe, TranslateDirective } from '@ngx-translate/core';
import { EcplPdfViewerModule } from 'src/app/shared/ecpl-pdf-viewer';
import { ConfirmationService } from 'primeng/api';
import { ClipboardModule } from 'ngx-clipboard';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { EditComponent } from './components/safety-job-analysis-edit.component';
@NgModule({ exports: [
        SafetyjobComponent,
        NewComponent,
        ListComponent,
        FormComponent,
        EditComponent,
  ],
    declarations: [
    SafetyjobComponent,
    NewComponent,
    ListComponent,
    FormComponent,
    EditComponent,
  ], imports: [FormsModule,
        CommonModule,
        AppSharedModule,
        EcplPdfViewerModule,
        RouterModule,
        TranslatePipe, TranslateDirective,
        ConfirmDialogModule,
        EcplDocumentExplorerModule,
        ClipboardModule
  ],
  providers: [
    JobAnalysisService,
    ConfirmationService,
    SafteyJobEditResolver,
    SafteyJobListResolver,
    TypeOfIssueResolver,
    TopicResolver,
    SJAApprovalNoticeListResolver,
    EmployeeContactUserResolver,
        provideHttpClient(withInterceptorsFromDi()),
    ]
})
export class JobAnalysisModule {}
